import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userLoginFailureClearAction } from '../store/user';
import Environment from '../shared/Environment';
import { GoogleLoginButton } from './GoogleButtons';

class LoginPageView extends Component {
  getUrlErrorMessage() {
    const params = new URLSearchParams(window.location.search);
    return params.get('error');
  }

  componentDidMount() {
    // Clear any previous error state when the page loads
    this.props.userLoginFailureClearAction();
  }

  renderErrorMessage(errorMessage) {
    return errorMessage && <div className="alert alert-danger mb-4" role="alert">{errorMessage}</div>;
  }

  render() {
    const urlError = this.getUrlErrorMessage();

    return (
      <div>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">&nbsp;</div>
        </nav>
        <div className="container-fluid my-4">
          <div className="row">
            <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
              <div className="card">
                <div className="card-body p-5">
                  <h4 className="card-title">Authenticatie vereist</h4>
                  <p className="mb-4">Log in met uw account van {Environment.TITLE}.</p>

                  {this.renderErrorMessage(urlError)}
                  {this.renderErrorMessage(this.props.errorMessage)}

                  <GoogleLoginButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  errorMessage: state.user && state.user.errorMessage,
});
const mapDispatchToProps = (dispatch) => ({
  userLoginFailureClearAction: () => dispatch(userLoginFailureClearAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageView);
